import { useQuery } from '@tanstack/react-query'
import { useAxios } from 'packages/core'
import config from 'config'

export const TRANSLATIONS_KEY = 'TRANSLATIONS'
export const AVAILABLE_LANGUAGES_KEY = 'AVAILABLE_LANGUAGES'
export const ANONYMOUS_TRANSLATIONS_KEY = 'ANONYMOUS_TRANSLATIONS'

export const useTranslations = () => {
    const callApi = useAxios()
    return useQuery(
        [TRANSLATIONS_KEY],
        () =>
            callApi({
                method: 'GET',
                url: '/api/localization?resourceSet=MyTasks',
            }).then((data) => data.data),
        {
            staleTime: Infinity,
        },
    )
}

export const useAvailableLocales = () => {
    const callApi = useAxios()
    return useQuery(
        [AVAILABLE_LANGUAGES_KEY],
        () =>
            callApi({
                method: 'GET',
                url: '/api/Localization/languages',
            }).then((data) => data.data),
        {
            staleTime: Infinity,
        },
    )
}

export const useAnonymousTranslations = () => {
    const callApi = useAxios()
    const locale = config.FALLBACK_LOCALE

    return useQuery(
        [ANONYMOUS_TRANSLATIONS_KEY],
        () =>
            callApi({
                method: 'GET',
                url: `/api/Localization/anonymous?language=${locale}`,
            }).then((data) => data.data),
        {
            staleTime: Infinity,
        },
    )
}
